import { render, staticRenderFns } from "./other-ele.vue?vue&type=template&id=fb08c9b8&scoped=true&"
import script from "./other-ele.vue?vue&type=script&lang=js&"
export * from "./other-ele.vue?vue&type=script&lang=js&"
import style0 from "./other-ele.vue?vue&type=style&index=0&id=fb08c9b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb08c9b8",
  null
  
)

export default component.exports